import React, { useState } from 'react';
import { V2Engine, V2AlertSettings, previewAlertSettings, applyPatch } from '../../services/optionsTraderV2Service';

const LABEL: Record<keyof V2AlertSettings, string> = { enabled: 'Alerts on', email: 'Email', sms: 'Text messages' };
const QUESTION: Record<keyof V2AlertSettings, [string, string]> = {
  enabled: ['Turn alerts on for this engine?', 'Turn alerts off for this engine? Urgent "action needed" alerts still go out.'],
  email: ['Turn email alerts on for this engine?', 'Turn email alerts off for this engine?'],
  sms: ['Turn text messages on for this engine?', 'Turn text messages off for this engine?'],
};
/** Engine alert switches (SP4 §8). Each change is preview -> Confirm (engine preview-patch + PATCH). */
const AlertSwitches: React.FC<{ token: string; engine: V2Engine; onChanged: (e: V2Engine) => void }> = ({ token, engine, onChanged }) => {
  const cur: V2AlertSettings = { enabled: true, email: true, sms: true, ...((engine.effectiveConfig || {}).alerts || {}) };
  const [pending, setPending] = useState<{ key: keyof V2AlertSettings; next: V2AlertSettings; planId: string } | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const start = async (key: keyof V2AlertSettings) => {
    setErr(null);
    const next = { ...cur, [key]: !cur[key] };
    try { const p = await previewAlertSettings(token, engine.engineId, next); setPending({ key, next, planId: p.planId }); }
    catch (e: any) { setErr(e?.message || 'Could not preview the change'); }
  };
  const confirm = async () => {
    if (!pending) return;
    try { const r = await applyPatch(token, engine.engineId, pending.planId); onChanged(r.engine); setPending(null); }
    catch (e: any) { setErr(e?.message || 'Could not save the change'); }
  };
  return (
    <div style={{ display: 'flex', gap: 12, alignItems: 'center', flexWrap: 'wrap', marginTop: 12, fontSize: 13, color: '#d1d5db' }}>
      {(Object.keys(LABEL) as (keyof V2AlertSettings)[]).map(k => (
        <label key={k} style={{ display: 'flex', gap: 4, alignItems: 'center' }}>
          <input type="checkbox" aria-label={LABEL[k]} checked={!!cur[k]} disabled={k !== 'enabled' && !cur.enabled} onChange={() => start(k)} />{LABEL[k]}
        </label>
      ))}
      {pending && (
        <span>
          {QUESTION[pending.key][pending.next[pending.key] ? 0 : 1]}{' '}
          <button onClick={confirm}>Confirm</button> <button onClick={() => setPending(null)}>Cancel</button>
        </span>
      )}
      {err && <span style={{ color: '#f87171' }}>{err}</span>}
    </div>
  );
};
export default AlertSwitches;
